import axios from "axios";

const browserTimezoneOffset = new Date().getTimezoneOffset() * -1;
export const user = axios.create({
  baseURL: `${process.env.REACT_APP_SERVICE_USERS_URL}`,
  headers: { "Timezone-offset": browserTimezoneOffset }
});

export const diagnostic = axios.create({
  baseURL: `${process.env.REACT_APP_SERVICE_DIAGNOSTICS_URL}`,
  headers: { "Timezone-offset": browserTimezoneOffset }
});



// WEBPACK FOOTER //
// ./src/modules/api/services.js